import { PersonHttpHelper, NO_DATA_MESSAGE } from '@usas/ui-web/utils/HttpHelper';

const PutMessageData = (personInboxId, messageObj, state, setState) => {
  if (state.isSaving !== true && !state.message) {
    const newState = {
      ...state,
      isSaving: true,
      isSaved: false,
      message: 'Saving...'
    };
    setState(newState);

    const personInboxIdForUrl = personInboxId ? encodeURIComponent(personInboxId) : 'NaN';
    const url = `/PersonInbox/${personInboxIdForUrl}/Read`;
    PersonHttpHelper(url, 'PUT', messageObj)
      .then((objData) => {
        if (!objData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          setState({
            ...newState,
            objData,
            isSaving: false,
            isSaved: true,
            message: ''
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isSaving: false,
          isSaved: false,
          message: message
        });
      });
  }
};

export default PutMessageData;